/** Public transporter credentials shown on the marketing site. */
export const COMPANY_CREDENTIALS = {
  usdot: '4487737',
  epaId: 'CAR000373571',
} as const

export default COMPANY_CREDENTIALS
